import React, { useEffect, useState } from 'react';
import { getDataAPI } from '../../Helpers/FetchAPI';
import { Autocomplete, TextField, Chip } from '@mui/material';
import { logger } from '../../utils/logger';

/**
 * WorkbookV2Picker Component
 * 
 * A multi-select picker for Workbook V2
 * @param {string[]} value - Array of selected workbook IDs
 * @param {function} onChange - Callback when selection changes, receives array of workbook IDs
 * @param {string} label - Label for the input field
 */
const WorkbookV2Picker = ({ value = [], onChange, label = 'Related Workbooks' }) => {
  const [workbooks, setWorkbooks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedWorkbooks, setSelectedWorkbooks] = useState([]);

  useEffect(() => {
    setLoading(true);
    getDataAPI('/workbook/v2/list')
      .then((res) => {
        const workbookList = res.data || [];
        setWorkbooks(workbookList);

        if (value && value.length > 0) {
          const selected = workbookList.filter(wb => value.includes(wb._id));
          setSelectedWorkbooks(selected);
        }
      })
      .catch((err) => {
        logger.error('Error fetching workbooks', err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // Update selected workbooks when value prop changes externally
  useEffect(() => {
    if (workbooks.length > 0) {
      const selected = workbooks.filter(wb => value && value.includes(wb._id));
      setSelectedWorkbooks(selected);
    }
  }, [value, workbooks]);

  const handleChange = (event, newValue) => {
    setSelectedWorkbooks(newValue);
    
    // Call onChange with array of workbook IDs
    if (onChange) {
      onChange(newValue.map(wb => wb._id));
    }
  };

  return (
    <Autocomplete
      multiple
      id="workbook-v2-picker"
      options={workbooks}
      value={selectedWorkbooks}
      onChange={handleChange}
      loading={loading}
      getOptionLabel={(option) => option.title || 'Untitled Workbook'}
      isOptionEqualToValue={(option, value) => option._id === value._id}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={selectedWorkbooks.length === 0 ? 'Select workbooks...' : ''}
        />
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            label={option.title || 'Untitled'}
            {...getTagProps({ index })}
            key={option._id}
          />
        ))
      }
    />
  );
};

export default WorkbookV2Picker;

